import { useEffect, useState, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, ArrowRight } from "lucide-react";
import { API } from "../../App";
const PageSectionEditor = lazy(() => import("../admin/PageSectionEditor"));
import { renderInline } from "../blocks/renderInline";
import { absUrl } from "../blocks/media";

export const SEASON_DEFAULTS = {
  eyebrow: "The Season to Build HOPE", title: "Holiday HOPE Hop",
  body: "Peace Day to the Santa Parade: businesses add a free Gem, artists add music, and the whole South Sound gets a Map of Gems for the holidays. **Gems are live now — the full 2026 Holiday HOPE Hop Map of Gems publishes Nov 13, 2026.**",
  bg_image: "/api/uploads/art/hop_santa_moon_8064c3.jpg", show_timeline: true, highlight_date: "2026-11-13", highlight_label: "HOARD LIVE",
  cta_label: "Explore the Holiday HOPE Hop", cta_url: "/holiday-hop", show_badge: true, badge_layout_key: "home:featured-badge",
};
const fmt = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

export const HomeSeasonStrip = ({ block }) => {
  const cfg = { ...SEASON_DEFAULTS, ...(block?.config || {}) };
  const [dates, setDates] = useState([]);
  useEffect(() => { if (cfg.show_timeline) axios.get(`${API}/holiday-hop`).then((r) => setDates(r.data?.settings?.season_dates || [])).catch(() => {}); }, [cfg.show_timeline]);
  const today = new Date().toISOString().slice(0, 10);
  return (
    <section className="relative overflow-hidden text-[#FBEED2]" style={{ backgroundImage: `linear-gradient(180deg, rgba(10,6,18,.78), rgba(10,6,18,.92)), url(${absUrl(cfg.bg_image)})`, backgroundSize: "cover", backgroundPosition: "center 35%" }} data-testid="holiday-hop-strip">
      <div className={`max-w-7xl mx-auto px-6 md:px-12 py-14 sm:py-20 grid gap-10 items-start ${cfg.show_badge ? "lg:grid-cols-[1.35fr_1fr]" : ""}`}>
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em]"><Sparkles className="h-3.5 w-3.5" /> {cfg.eyebrow}</div>
          <h2 className="mt-4 font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05]">{block?.title || cfg.title}</h2>
          <p className="mt-3 text-base sm:text-lg text-[#FBEED2]/90 max-w-2xl [&_strong]:text-white">{renderInline(block?.quip || cfg.body, "#F2CC8F")}</p>
          {cfg.show_timeline && (
            <ol className="mt-8 grid gap-3 sm:grid-cols-2" data-testid="hop-timeline">
              {dates.map((d) => {
                const past = d.date < today;
                return (
                  <li key={d.date} className={`rounded-xl border p-3.5 transition-colors ${past ? "border-white/10 bg-white/[0.03] text-[#FBEED2]/60" : "border-[#F2CC8F]/40 bg-white/5"}`} data-testid={`hop-date-${d.date}`}>
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F2CC8F]">{fmt(d.date)}{d.date === cfg.highlight_date && cfg.highlight_label ? ` · ${cfg.highlight_label}` : ""}</div>
                    <div className="mt-1 text-sm font-extrabold leading-snug">{d.label}</div>
                    {d.detail && <div className="mt-0.5 text-xs leading-snug opacity-80">{d.detail}</div>}
                  </li>
                );
              })}
            </ol>
          )}
          {cfg.cta_label && <Link to={cfg.cta_url} className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#15803D] px-5 py-3 text-sm font-bold text-white hover:bg-[#166534] active:scale-95 transition-[background-color,transform] shadow-md" data-testid="hop-cta-button">{cfg.cta_label} <ArrowRight className="h-4 w-4" /></Link>}
        </div>
        {cfg.show_badge && (
          <div className="lg:pt-10" data-testid="hop-featured-badge">
            <Suspense fallback={null}><PageSectionEditor layoutKey={cfg.badge_layout_key} emptyMessage="Add a featured badge here." /></Suspense>
          </div>
        )}
      </div>
    </section>
  );
};
